// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"kR-z","carouselContainer":"lR-z"};